module.exports = __webpack_public_path__ + "img/roll_s_f.3ab11c63.png";